import { PortalDebitAttemptResponse } from "../contracts/PortalDebitAttemptResponse";
import { PortalPaymentResponse } from "../contracts/PortalPaymentResponse";
import { PortalPayment, PortalPendingDebit } from "../models/PortalPayment";

/** Wire → UI for the Money list; absent or null optional fields become null. */
export class PortalPaymentResponseMapper {
  toPendingDebit = (resp: PortalDebitAttemptResponse): PortalPendingDebit => ({
    id: resp.id,
    initiatedAt: resp.initiatedAt,
    expectedSettlementDate: resp.expectedSettlementDate ?? null,
  });

  toItem = (resp: PortalPaymentResponse): PortalPayment => ({
    id: resp.id,
    shape: resp.shape,
    status: resp.status,
    amountMinorUnits: resp.amountMinorUnits,
    amountCurrency: resp.amountCurrency,
    dueDate: resp.dueDate ?? null,
    remainingBalance: resp.remainingBalance ?? null,
    billingPeriodStart: resp.billingPeriodStart ?? null,
    billingPeriodEnd: resp.billingPeriodEnd ?? null,
    dateCreated: resp.dateCreated,
    document:
      resp.documentKind != null && resp.documentNumber != null
        ? { kind: resp.documentKind, number: resp.documentNumber }
        : null,
    canPayNow: resp.canPayNow,
    pendingDebit: resp.pendingDebit ? this.toPendingDebit(resp.pendingDebit) : null,
    payLinkUrl: resp.payLinkUrl ?? null,
  });

  toItems = (responses: PortalPaymentResponse[]): PortalPayment[] => responses.map(this.toItem);
}
